module.exports = __webpack_public_path__ + "static/media/shop-02.0ee93742.jpg";